// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"statusTitle_subTitle__2CtVG","title":"statusTitle_title__3eusY"};